import React, { useEffect, useState } from "react";
import OnboardingLayout from "./OnboardingLayout";
import duolingoLogo from "../../assets/duolingo-logo.png";
import babbelLogo from "../../assets/babbel-logo.png";
import busuuLogo from "../../assets/busuu-logo.png";
import parrotLogo from "../../assets/parrot-logo.png";
// console.log("Image import test:", testLogo);
const Credibility: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Reset animation state
    setIsVisible(false);
    // Small delay to ensure animation triggers
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 50);
    // Cleanup function to reset state when component unmounts
    return () => {
      clearTimeout(timer);
      setIsVisible(false);
    };
  }, []);
  return (
    <OnboardingLayout
      title="Gain twice as much progress with Parrot"
      subtitle="Learn new languages 2.7x faster with Parrot's proven learning method."
    >
      <div className="p-4 mx-auto max-w-[500px] w-[calc(100%-40px)] h-full flex flex-col gap-6 justify-center">
        <div className="flex flex-row gap-7 h-2/3 items-end">
          <div
            className={`flex flex-col items-center gap-3 flex-1 h-full justify-end translate-y-4 opacity-0 transition-all duration-700 ease-out ${
              isVisible ? "translate-y-0 opacity-100" : ""
            }`}
            style={{ transitionDelay: "200ms" }}
          >
            <div className="flex flex-col gap-0 mb--4">
              <img
                src={duolingoLogo}
                alt="Duolingo"
                className="w-12 h-12 object-contain opacity-40"
              />
              <img
                src={babbelLogo}
                alt="Babbel"
                className="w-12 h-12 object-contain opacity-40"
              />
              <img
                src={busuuLogo}
                alt="Busuu"
                className="w-12 h-12 object-contain opacity-40"
              />
            </div>
            <div className="w-full h-[30%] min-h-[40px] bg-[var(--color-grey-light)] rounded-xl relative flex items-center justify-center min-w-[60px] mt-1">
              <span className="text-white font-bold text-base">1x</span>
            </div>
            <span className="text-center">Other apps</span>
          </div>
          <div
            className={`flex flex-col items-center gap-3 flex-1 h-full justify-end translate-y-4 opacity-0 transition-all duration-700 ease-out ${
              isVisible ? "translate-y-0 opacity-100" : ""
            }`}
            style={{ transitionDelay: "400ms" }}
          >
            <img
              src={parrotLogo}
              alt="Parrot"
              className={`w-8 h-8 object-contain mb-0 transition-all duration-[1500ms] ease-out relative ${
                isVisible ? "-translate-y-[120%]" : ""
              }`}
              style={{ transitionDelay: "600ms" }}
            />
            <div
              className={`w-full min-h-[40px] bg-[var(--color-grey-light)] rounded-xl relative flex items-center justify-center min-w-[60px] mt-1 transition-all duration-[1500ms] ease-out ${
                isVisible ? "h-[73%] !bg-[var(--color-orange)]" : "h-[30%]"
              }`}
              style={{ transitionDelay: "600ms" }}
            >
              <span className="text-white font-bold text-base">2.7x</span>
            </div>
            <span className="text-center">With Parrot</span>
          </div>
        </div>
      </div>
    </OnboardingLayout>
  );
};
export default Credibility;